<template>
  <div>
    <form
      v-if="status === 'success'"
      class="kt-form"
      @submit.prevent="update"
      id="profile_form"
    >
      <div class="d-flex align-items-center px-3">
        <div class="ml-auto">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 0 24 24"
            width="24px"
            fill="#00bea5"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
            />
          </svg>
          <span class="pr-2">حساب کاربری</span>
        </div>
        <div>
          <button
            type="submit"
            class="btn btn-success px-4"
            style="border-radius: 10px"
            id="submit_btn"
            :disabled="form_submit_loading"
          >
            <span v-if="form_submit_loading">
              <span class="pl-2">در حال انجام</span>
              <span
                class="spinner-border spinner-border-sm p-2"
                role="status"
              ></span>
            </span>
            <span v-else>ثبت تغییرات</span>
          </button>
        </div>
      </div>
      <hr />
      <div class="p-3">
        <div>
          <div class="h5 mb-4">
            <i class="text-success far fa-building"></i>
            <span class="px-4">{{ $t("legal_user.label.company_info") }}</span>
          </div>
          <div>
            <div class="row">
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="username">
                    {{ $t("label.username_with_hint") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    dir="ltr"
                    name="username"
                    id="username"
                    v-model="user.username"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="email">
                    {{ $t("label.email") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    dir="ltr"
                    name="email"
                    id="email"
                    v-model="user.email"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="com_name_fa">
                    {{ $t("label.com_name_fa") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="com_name_fa"
                    name="com_name_fa"
                    v-model="user.com_name_fa"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="com_name_en">
                    {{ $t("label.com_name_en") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="com_name_en"
                    name="com_name_en"
                    dir="ltr"
                    v-model="user.com_name_en"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="national_legal_code">
                    {{ $t("label.national_legal_code") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="national_legal_code"
                    name="national_legal_code"
                    v-model="user.national_legal_code"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="register_number">
                    {{ $t("label.register_number") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="register_number"
                    name="register_number"
                    v-model="user.register_number"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="register_date">
                    {{ $t("label.com_register_date") }}
                  </label>
                  <datePicker
                    color="#00c1a4"
                    format="YYYY-MM-DD HH:mm:ss"
                    display-format="jDD jMMMM jYYYY"
                    input-class="form-control"
                    id="register_date"
                    name="register_date"
                    v-model="user.register_date"
                    :disabled="user.is_authenticated"
                    type="date"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="telephone">
                    {{ $t("label.telephone") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    ref="telephone"
                    dir="ltr"
                    name="telephone"
                    id="telephone"
                    v-model="user.telephone"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="phone">
                    {{ $t("label.phone") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    dir="ltr"
                    disabled
                    name="phone"
                    id="phone"
                    :value="user.phone"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr style="border-top: 1px solid #dedede" class="my-4" />

        <div>
          <div class="h5 mb-4">
            <i class="text-success fas fa-file-signature"></i>
            <span class="px-4">{{
              $t("legal_user.label.signature_holder_info")
            }}</span>
          </div>
          <div>
            <div class="row">
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="signature_holder_first_name_fa">
                    {{ $t("label.first_name") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    name="signature_holder_first_name_fa"
                    id="signature_holder_first_name_fa"
                    v-model="user.signature_holder.first_name_fa"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="signature_holder_first_name_en">
                    {{ $t("label.first_name_en") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    dir="ltr"
                    name="signature_holder_first_name_en"
                    id="signature_holder_first_name_en"
                    v-model="user.signature_holder.first_name_en"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="signature_holder_last_name_fa">
                    {{ $t("label.last_name") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    name="signature_holder_last_name_fa"
                    id="signature_holder_last_name_fa"
                    v-model="user.signature_holder.last_name_fa"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="signature_holder_last_name_en">
                    {{ $t("label.last_name_en") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    dir="ltr"
                    name="signature_holder_last_name_en"
                    id="signature_holder_last_name_en"
                    v-model="user.signature_holder.last_name_en"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="signature_holder_father_name_fa">
                    {{ $t("label.father_name") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    name="signature_holder_father_name_fa"
                    id="signature_holder_father_name_fa"
                    v-model="user.signature_holder.father_name_fa"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="signature_holder_father_name_en">
                    {{ $t("label.father_name_en") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    dir="ltr"
                    name="signature_holder_father_name_en"
                    id="signature_holder_father_name_en"
                    v-model="user.signature_holder.father_name_en"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="signature_holder_birth_date">
                    {{ $t("label.birth_date") }}
                  </label>
                  <datePicker
                    color="#00c1a4"
                    format="YYYY-MM-DD HH:mm:ss"
                    display-format="dddd jDD jMMMM jYYYY"
                    input-class="form-control"
                    id="signature_holder_birth_date"
                    name="signature_holder_birth_date"
                    v-model="user.signature_holder.birth_date"
                    :disabled="user.is_authenticated"
                    type="date"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="signature_holder_national_code">
                    {{ $t("label.national_code") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    dir="ltr"
                    maxlength="10"
                    name="signature_holder_national_code"
                    id="signature_holder_national_code"
                    v-model="user.signature_holder.national_code"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr style="border-top: 1px solid #dedede" class="my-4" />

        <div>
          <div class="h5 mb-4">
            <i class="text-success fas fa-laptop-code"></i>
            <span class="px-4">{{
              $t("legal_user.label.technical_agent_info")
            }}</span>
          </div>
          <div>
            <div class="row">
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="technical_agent_first_name">
                    {{ $t("label.first_name") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    name="technical_agent_first_name"
                    id="technical_agent_first_name"
                    v-model="user.technical_agent.first_name"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="technical_agent_last_name">
                    {{ $t("label.last_name") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="technical_agent_last_name"
                    name="technical_agent_last_name"
                    v-model="user.technical_agent.last_name"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="technical_agent_phone_number">
                    {{ $t("label.phone") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    dir="ltr"
                    id="technical_agent_phone_number"
                    name="technical_agent_phone_number"
                    v-model="user.technical_agent.phone_number"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="technical_agent_telephone_number">
                    {{ $t("label.telephone") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    dir="ltr"
                    id="technical_agent_telephone_number"
                    name="technical_agent_telephone_number"
                    v-model="user.technical_agent.telephone_number"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="technical_agent_email">
                    {{ $t("label.email") }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    dir="ltr"
                    id="technical_agent_email"
                    name="technical_agent_email"
                    v-model="user.technical_agent.email"
                    :disabled="user.is_authenticated"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 my-2">
                <div>
                  <label for="technical_agent_national_code">
                    {{ $t('label.national_code') }}
                  </label>
                  <input type="text" class="form-control"
                    dir="ltr"
                    id="technical_agent_national_code"
                    name="technical_agent_national_code"
                    v-model="user.technical_agent.national_code"
                         :disabled="user.is_authenticated"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr style="border-top: 1px solid #dedede" class="my-4" />
        <div>
          <div class="h5 mb-4">
            <i class="text-success fas fa-laptop-code"></i>
            <span class="px-4">{{
              $t("label.social_media")
            }}</span>
          </div>
          <div>
            <div class="d-flex align-items-center">
              <div class="form-group w-50 px-3">
                <i class="la la-instagram ml-2" style="font-size: 15px"></i>
                <label for="instagram">آی دی اینستاگرام (بدون @)</label>
                <input
                    type="text"
                    dir="ltr"
                    id="instagram"
                    class="form-control text-left"
                    v-model="user.social_network.instagram"

                />
              </div>
              <div class="form-group w-50 px-3">
                <svg xmlns="http://www.w3.org/2000/svg" class="ml-2" fill="#A0A0A1" viewBox="0 0 48 48" width="15px" height="15px"><path d="M 15.173828 2.609375 C 11.917119 2.5264688 8.94875 4.7335781 8.1875 8.0332031 L 7.078125 12.837891 C 10.172125 7.7938906 15.497719 4.4664844 21.386719 3.8964844 L 16.582031 2.7871094 C 16.110656 2.6782344 15.639072 2.6212187 15.173828 2.609375 z M 24 7 C 14.628921 7 7 14.628928 7 24 C 7 33.371072 14.628921 41 24 41 C 33.371079 41 41 33.371072 41 24 C 41 14.628928 33.371079 7 24 7 z M 35.162109 7.078125 C 40.206109 10.172125 43.533516 15.497719 44.103516 21.386719 L 45.212891 16.582031 C 46.083891 12.811031 43.737797 9.0575 39.966797 8.1875 L 35.162109 7.078125 z M 24 10 C 31.74976 10 38 16.250245 38 24 C 38 31.749755 31.74976 38 24 38 C 16.25024 38 10 31.749755 10 24 C 10 16.250245 16.25024 10 24 10 z M 20.228516 13.697266 A 3.5 3.5 0 1 0 20.228516 20.697266 A 3.5 3.5 0 1 0 20.228516 13.697266 z M 30.802734 16.728516 A 3.5 3.5 0 1 0 30.802734 23.728516 A 3.5 3.5 0 1 0 30.802734 16.728516 z M 24 22.001953 A 1.999 1.999 0 1 0 24 25.998047 A 1.999 1.999 0 1 0 24 22.001953 z M 17.197266 24.271484 A 3.5 3.5 0 1 0 17.197266 31.271484 A 3.5 3.5 0 1 0 17.197266 24.271484 z M 3.8964844 26.615234 L 2.7871094 31.419922 C 1.9171094 35.190922 4.2622031 38.943453 8.0332031 39.814453 L 12.837891 40.923828 C 7.7948906 37.829828 4.4664844 32.504234 3.8964844 26.615234 z M 27.771484 27.302734 A 3.5 3.5 0 1 0 27.771484 34.302734 A 3.5 3.5 0 1 0 27.771484 27.302734 z M 40.923828 35.162109 C 37.829828 40.205109 32.504234 43.533516 26.615234 44.103516 L 31.419922 45.212891 C 35.190922 46.082891 38.943453 43.737797 39.814453 39.966797 L 40.923828 35.162109 z"/></svg>
                <label for="aparat">آی دی آپارات (بدون @)</label>
                <input
                    type="text"
                    dir="ltr"
                    id="aparat"
                    class="form-control text-left"
                    v-model="user.social_network.aparat"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import { mapState } from "vuex";
import { userService } from "@/common/api.service";
import Inputmask from "inputmask";
import { i18n } from "@/plugins/i18n";
import { birthCrtfctSeriesLetters } from "@/constants/birthCrtfctSeriesLetter";

export default {
  props: {
    user: Object,
  },
  data: function () {
    return {
      form_submit_loading: false,
      birthCrtfctSeriesLetters: birthCrtfctSeriesLetters,
      months: [
        {
          title: i18n.t("month.farvardin"),
          value: 1,
        },
        {
          title: i18n.t("month.ordibehesht"),
          value: 2,
        },
        {
          title: i18n.t("month.khordad"),
          value: 3,
        },
        {
          title: i18n.t("month.tir"),
          value: 4,
        },
        {
          title: i18n.t("month.mordad"),
          value: 5,
        },
        {
          title: i18n.t("month.shahrivar"),
          value: 6,
        },
        {
          title: i18n.t("month.mehr"),
          value: 7,
        },
        {
          title: i18n.t("month.aban"),
          value: 8,
        },
        {
          title: i18n.t("month.azar"),
          value: 9,
        },
        {
          title: i18n.t("month.day"),
          value: 10,
        },
        {
          title: i18n.t("month.bahman"),
          value: 11,
        },
        {
          title: i18n.t("month.esfand"),
          value: 12,
        },
      ],
    };
  },
  computed: {
    ...mapState("user", {
      status: (state) => state.status,
    }),
  },
  mounted() {
    this.$nextTick(function () {
      this.initialSetup();
    });
  },
  methods: {
    checkForDisableForm() {
      if (this.user.is_authenticated) {
        $("#profile_form :input").prop("disabled", true);
      }
    },
    initialSetup() {
      setTimeout(() => {
        document.getElementById("telephone") &&
          Inputmask("099-99999999").mask(document.getElementById("telephone"));
      }, 1000);
    },
    update(e) {
      let form = $(e.target);
      let btn = $("#submit_btn");
      let params;
      if (!this.user.is_authenticated) {
        form.validate({
          ignore: ":hidden",

          rules: {
            username: {
              required: true,
              minlength: 5,
            },
            email: {
              required: true,
            },
            telephone: {
              required: true,
            },
            phone: {
              required: true,
            },
            com_name_fa: {
              required: true,
            },
            com_name_en: {
              required: true,
            },
            national_legal_code: {
              required: true,
            },
            register_number: {
              required: true,
            },
            register_date: {
              required: true,
            },

            signature_holder_first_name_fa: {
              required: true,
            },
            signature_holder_last_name_fa: {
              required: true,
            },
            signature_holder_father_name_fa: {
              required: true,
            },
            signature_holder_first_name_en: {
              required: true,
            },
            signature_holder_last_name_en: {
              required: true,
            },
            signature_holder_father_name_en: {
              required: true,
            },
            signature_holder_national_code: {
              required: true,
            },
            signature_holder_birth_date: {
              required: true,
            },

            technical_agent_first_name: {
              required: true,
            },
            technical_agent_last_name: {
              required: true,
            },
            technical_agent_phone_number: {
              required: true,
            },
            technical_agent_telephone_number: {
              required: true,
            },
            technical_agent_email: {
              required: true,
            },
          },
        });

        if (!form.valid()) {
          window.scrollTo({top: 0, behavior: "smooth"});
          return;
        }

          params = {
          username: this.user.username,
          email: this.user.email,
          phone: this.user.phone,
          telephone: this.user.telephone,
          com_name_fa: this.user.com_name_fa,
          com_name_en: this.user.com_name_en,
          national_legal_code: this.user.national_legal_code,
          register_number: this.user.register_number,
          register_date: this.user.register_date,

          signature_holder_first_name_fa:
          this.user.signature_holder.first_name_fa,
          signature_holder_last_name_fa: this.user.signature_holder.last_name_fa,
          signature_holder_father_name_fa:
          this.user.signature_holder.father_name_fa,
          signature_holder_first_name_en:
          this.user.signature_holder.first_name_en,
          signature_holder_last_name_en: this.user.signature_holder.last_name_en,
          signature_holder_father_name_en:
          this.user.signature_holder.father_name_en,
          signature_holder_national_code:
          this.user.signature_holder.national_code,
          signature_holder_birth_date: this.user.signature_holder.birth_date,

          technical_agent_first_name: this.user.technical_agent.first_name,
          technical_agent_last_name: this.user.technical_agent.last_name,
          technical_agent_phone_number: this.user.technical_agent.phone_number,
          technical_agent_telephone_number:
          this.user.technical_agent.telephone_number,
          technical_agent_email: this.user.technical_agent.email,
        };
      } else {
         params = {
          instagram: this.user.social_network.instagram,
          aparat: this.user.social_network.aparat
        }
      }

      this.form_submit_loading = true;
      userService
        .update_legal_user(params)
        .then((response) => {
          this.$store.commit("user/success", response.data.data);
          this.showMsg(form, 'success', response.data.message);
        })
        .catch(({ response }) => {
          if (response.data) {
            form.validate().showErrors(response.data.data);
          }
          this.showMsg(form, "danger", response.data.message);
          window.scrollTo({ top: 0, behavior: "smooth" });
        })
        .finally(() => {
          this.form_submit_loading = false;
        });
    },
    getYear() {
      return new Date().getFullYear() - 721;
    },
  },
};
</script>
